import { environment } from '../../../../environments/environment';
import { Client } from '../../models/client';

export const CONTENTFUL = environment.contentful;

export const $TRAIL = '$trail';
export const FEATURE_DISCOVERY = 'FEATURE_DISCOVERY';

export const VISIBLE_AGENTS = {
  cs: [
    'cs',
    'csm',
    'csAdmin',
    'supportSpecialist',
    'sales',
    'clientAdmin',
    'dachAdmin',
    'hr',
    'distributorManager',
    'distributor',
    'expert',
    'student'
  ],
  csm: [
    'cs',
    'csm',
    'csAdmin',
    'supportSpecialist',
    'sales',
    'clientAdmin',
    'dachAdmin',
    'hr',
    'distributorManager',
    'distributor',
    'expert',
    'student'
  ],
  supportSpecialist: [
    'cs',
    'csm',
    'csAdmin',
    'supportSpecialist',
    'sales',
    'clientAdmin',
    'dachAdmin',
    'hr',
    'distributorManager',
    'distributor',
    'expert',
    'student'
  ],
  csAdmin: [
    'cs',
    'csm',
    'csAdmin',
    'supportSpecialist',
    'sales',
    'clientAdmin',
    'dachAdmin',
    'hr',
    'distributorManager',
    'distributor',
    'expert',
    'student'
  ],
  sales: [
    'cs',
    'csm',
    'csAdmin',
    'supportSpecialist',
    'sales',
    'clientAdmin',
    'dachAdmin',
    'hr',
    'distributorManager',
    'distributor',
    'expert',
    'student'
  ],
  salesChief: [
    'cs',
    'csm',
    'csAdmin',
    'supportSpecialist',
    'sales',
    'clientAdmin',
    'dachAdmin',
    'hr',
    'distributorManager',
    'distributor',
    'expert',
    'student'
  ],
  distributorManager: [
    'cs',
    'csm',
    'csAdmin',
    'supportSpecialist',
    'sales',
    'clientAdmin',
    'dachAdmin',
    'hr',
    'distributorManager',
    'distributor',
    'expert',
    'student'
  ],
  distributor: ['distributor', 'clientAdmin', 'dachAdmin', 'hr', 'student'],
  expert: ['expert', 'clientAdmin', 'dachAdmin', 'hr', 'student'],
  clientAdmin: ['clientAdmin', 'dachAdmin', 'hr', 'student'],
  dachAdmin: ['clientAdmin', 'dachAdmin', 'hr', 'student'],
  hr: ['clientAdmin', 'dachAdmin', 'hr', 'student'],
  student: [],
  demo: []
};

export const ROLES = {
  CS: 'cs', // role group includes csm, supportSpecialist
  CSM: 'csm',
  CSADMIN: 'csAdmin',
  SUPPORT_SPECIALIST: 'supportSpecialist',
  SALES: 'sales',
  SALES_CHIEF: 'salesChief',
  CLIENT_ADMIN: 'clientAdmin',
  DACH_ADMIN: 'dachAdmin',
  HR: 'hr', // hr role and role group wich includes hr, clientAdmin
  DISTRIBUTOR: 'distributor',
  EXPERT: 'expert',
  STUDENT: 'student',
  DEMO: 'demo',
  DISTRIBUTOR_MANAGER: 'distributorManager',
  SUPER_ADMIN: 'superAdmin'
};

// key used on permissions list to config context permissions
export const CONTEXT_PERMISSIONS_ENTRY = '$CONTEXT';
// permissions contexts
export const CONTEXTS = {
  // clients context
  clients: {
    key: '$CLIENTS',
    // veatures availables
    features: [
      {
        // client with gamification enabled
        key: '$GAMIFICATION',
        test: (client: Client | null) => client?.gamification?.enabled
      },
      {
        // client with roleplay enabled
        key: '$ROLEPLAY',
        test: (client: Client | null) => client?.productivityCfg?.roleplay?.enabled
      },
      {
        // client with kepler enabled
        key: '$KEPLER',
        test: (client: Client | null) => client?.productivityCfg?.kepler?.enabled
      },
      {
        // client with mars enabled
        key: '$MARS',
        test: (client: Client | null) => client?.productivityCfg?.mars?.enabled
      },
      {
        // scorm client
        key: '$SCORM',
        test: (client: Client | null) => client?.scorm?.enabled
      }
    ]
  }
};
